<template>
  <div class="am-loading-bar-base">
    <b-progress :max="max" class="am-loading-bar-base">
      <b-progress-bar :value="loadingBarValue" class="loading-bar am-loading-bar-progress"></b-progress-bar>
    </b-progress>
  </div>
</template>

<script>
export default {
  name: 'LoadingBar',
  data () {
    return {
      max: 100
    }
  },
  props: {
    loadingBarValue: {
      required: true,
      type: Number
    }
  }
}
</script>

<style lang="sass" scoped>
  .progress
    background-color: transparent
    height: 6px !important
    border-radius: 0 !important
    z-index: 8
    .loading-bar
      -webkit-transition: width 350ms
      -moz-transition: width 350ms
      -o-transition: width 350ms
      transition: width 350ms
</style>
